import { render, staticRenderFns } from "./VoiceAnimation.vue?vue&type=template&id=f9bbba0c&"
var script = {}
import style0 from "./VoiceAnimation.vue?vue&type=style&index=0&id=f9bbba0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports